/* Szybkie dobranie drugiego produktu w koszyku (szuflada i strona koszyka). */
(() => {
  if (window.__cpUpsellInit) return;
  window.__cpUpsellInit = true;

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-cp-upsell-add]');
    if (!btn) return;

    const root = btn.closest('[data-cp-upsell]');
    const select = root && root.querySelector('[data-cp-upsell-variant]');
    const msg = root && root.querySelector('[data-cp-upsell-msg]');
    if (!select || !select.value) return;

    const note = msg ? msg.textContent : '';
    const inDrawer = btn.dataset.context === 'drawer' && document.querySelector('cart-drawer');
    btn.disabled = true;
    btn.classList.add('is-loading');

    try {
      const body = { items: [{ id: Number(select.value), quantity: 1 }] };
      if (inDrawer) {
        body.sections = 'cart-drawer,cart-icon-bubble';
        body.sections_url = window.location.pathname;
      }
      const res = await fetch(btn.dataset.url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'add');

      if (inDrawer && data.sections && typeof document.querySelector('cart-drawer').renderContents === 'function') {
        document.querySelector('cart-drawer').renderContents(data);
      } else {
        window.location.reload();
      }
    } catch (e) {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      if (msg) {
        msg.textContent = 'Nie udało się dodać produktu. Wybierz inny rozmiar lub spróbuj jeszcze raz.';
        setTimeout(() => {
          msg.textContent = note;
        }, 5000);
      }
    }
  });
})();
